/** MODALMOBILE: TODO */
import React from 'react'

import LoginForm from '../hookforms/forms/LoginForm'
import ModalFullscreen, { Props } from './ModalFullscreen'

const ModalLogin: React.FC<Props> = (props) => {
  const { size, title, ...other } = props
  return (
    <ModalFullscreen size={size || 600} title={title || 'Log In'} {...other}>
      <LoginForm />
    </ModalFullscreen>
  )
}

export default ModalLogin
